import React, { useEffect, useRef } from "react";

const DEFAULT_SLIDER = '/defaults/default-slider.svg';
const handleImgError = (e) => { e.target.onerror = null; e.target.src = DEFAULT_SLIDER; };

function Sliders({ sliderAffiliate = [] }) {
  const sliderRef = useRef(null);
  const timerRef = useRef(null);
  const indexRef = useRef(0);
  const AUTO_SPEED = 3000;

  useEffect(() => {
    const root = sliderRef.current;
    if (!root) return;
    const slides = Array.from(root.querySelectorAll(".et_pb_slide"));
    if (slides.length === 0) return;

    slides.forEach(applyInactiveStyles);
    indexRef.current = 0;
    applyActiveStyles(slides[0]);

    const prev = root.querySelector(".et-pb-arrow-prev");
    const next = root.querySelector(".et-pb-arrow-next");

    const goPrev = (e) => { e?.preventDefault(); showSlide(indexRef.current - 1); restartAuto(); };
    const goNext = (e) => { e?.preventDefault(); showSlide(indexRef.current + 1); restartAuto(); };

    prev?.addEventListener("click", goPrev);
    next?.addEventListener("click", goNext);

    startAuto();
    const stopOnHover = () => stopAuto();
    const resumeOnLeave = () => startAuto();
    root.addEventListener("mouseenter", stopOnHover);
    root.addEventListener("mouseleave", resumeOnLeave);

    return () => {
      stopAuto();
      prev?.removeEventListener("click", goPrev);
      next?.removeEventListener("click", goNext);
      root.removeEventListener("mouseenter", stopOnHover);
      root.removeEventListener("mouseleave", resumeOnLeave);
    };

    function startAuto() { stopAuto(); timerRef.current = setInterval(() => { showSlide(indexRef.current + 1); }, AUTO_SPEED); }
    function stopAuto() { if (timerRef.current) clearInterval(timerRef.current); timerRef.current = null; }
    function restartAuto() { startAuto(); }

    function showSlide(nextIndex) {
      const total = slides.length;
      const newIndex = (nextIndex + total) % total;
      slides.forEach((s, i) => { if (i === newIndex) applyActiveStyles(s); else applyInactiveStyles(s); });
      indexRef.current = newIndex;
    }

    function applyActiveStyles(el) { el.classList.add("et-pb-active-slide"); el.style.display = "block"; el.style.opacity = "1"; el.style.zIndex = "1"; }
    function applyInactiveStyles(el) { el.classList.remove("et-pb-active-slide"); el.style.display = "none"; el.style.opacity = "0"; el.style.zIndex = "0"; }
  }, [sliderAffiliate.length]);

  if (!sliderAffiliate.length) return null;

  return (
    <div className="et_pb_section et_pb_section_2_tb_body et_section_regular">
      <div style={{ maxWidth: "100%" }} className="et_pb_row et_pb_row_0_tb_body">
        <div className="et_pb_column et_pb_column_4_4 et_pb_column_0_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
          <div ref={sliderRef} className="et_pb_module et_pb_slider et_pb_slider_tb_body et_pb_slider_fullwidth_off et_pb_slider_no_pagination et_slider_auto et_slider_speed_7000 et_pb_slider_show_image et_slide_transition_to_next et_pb_bg_layout_dark">
            <div className="et_pb_slides">
              {sliderAffiliate.map((slider, i) => {
                const imgPath = slider.thumbnail || slider.thubmnail;
                return (
                  <div key={i} className="et_pb_slide et_pb_slide_tb_body et_pb_bg_layout_dark et_pb_slide_with_image et_pb_media_alignment_center">
                    <div className="et_pb_container clearfix">
                      <div className="et_pb_slider_container_inner">
                        {imgPath && (
                          <div className="et_pb_slide_image">
                            <img fetchpriority={i === 0 ? "high" : undefined} decoding="async" src={`${process.env.REACT_APP_API_URL}/storage/${imgPath}`} alt={slider.alt || slider.name || ""} onError={handleImgError} />
                          </div>
                        )}
                        {!imgPath && (
                          <div className="et_pb_slide_image">
                            <img decoding="async" src={DEFAULT_SLIDER} alt="Slide" />
                          </div>
                        )}
                        <div className="et_pb_slide_description">
                          <div className="et_pb_slide_content">
                            {slider.name && <h2 className="yellow-color">{slider.name}</h2>}
                            {slider.link && <p dangerouslySetInnerHTML={{ __html: slider.link }} />}
                            {slider.link && <p><a href="#!" className="learn-more">{slider.linkText || "Learn More"}</a></p>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="et-pb-slider-arrows">
              <a className="et-pb-arrow-prev" href="#!" onClick={e => e.preventDefault()}><span>Previous</span></a>
              <a className="et-pb-arrow-next" href="#!" onClick={e => e.preventDefault()}><span>Next</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sliders;
